import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import calculatorData from '../models.js'
import { calculatorDataDefaults } from '../models.js'

import auth from './_auth.js'
import appInput from './_appInput.js'
import addToHomescreen from './_addToHomescreen.js'

const vuexLocal = new VuexPersistence({
  storage: window.localForage,
  reducer: (state) => ({
    calculatorDataDefaults: state.calculatorDataDefaults,
    persistentCalculatorsData: state.persistentCalculatorsData,
    auth: {
      sessionData: state.auth.sessionData,
      userData: state.auth.userData,
      emailVerified: state.auth.emailVerified
    }
  })
})

Vue.use(Vuex)

export const storeGenerator = () => {
  return new Vuex.Store({
    modules: {
      auth,
      appInput,
      addToHomescreen
    },
    state: {
      online: true,
      browserSupported: true,
      isMobile: true,
      calculatorDataDefaults: new calculatorDataDefaults(),
      calculatorsData: [new calculatorData(true)],
      persistentCalculatorsData: null,
    },
    mutations: {
      compare(state, currentCalculatorData) {
        currentCalculatorData.compared = true
        currentCalculatorData.collapsed = true
        state.calculatorsData.push(new calculatorData())
      },
      edit(state, currentCalculatorData) {
        currentCalculatorData.collapsed = false
      },
      collapse(state, currentCalculatorData) {
        currentCalculatorData.collapsed = true
      },
      persistState(state) {
        state.persistentCalculatorsData = state.calculatorsData
      },
      resumeState(state) {
        if (state.persistentCalculatorsData) {
          state.calculatorsData = state.persistentCalculatorsData
          state.persistentCalculatorsData = null  
        }
      }
    },
    actions: {
      compare(context, currentCalculatorData) {
        context.commit('compare', currentCalculatorData)
      },
      edit(context, currentCalculatorData) {
        context.commit('edit', currentCalculatorData)
      },
      collapse(context, currentCalculatorData) {
        context.commit('collapse', currentCalculatorData)
      },
      persistState(context) {
        context.commit('persistState')
      },
      resumeState(context) {
        context.commit('resumeState')
      }
    },
    plugins: [vuexLocal.plugin]
  })
}

export default storeGenerator()